import { createAction } from '@reduxjs/toolkit'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { FLAG_STROKE_WIDTH_DESELECTED } from '../../../constants/flagStyle'
import { NormalizedFlag } from '../../../models/flags'
import managers from '../../lib/managers'
import { Workspace } from '../../lib/toolBoxes/2D'
import { resetActiveFlag, selectIsFlagFormOpen, selectMaterialActiveFlag } from '../../slices/materialFlags'
import { setDisableFlagTool } from '../../slices/tools'

export const resetActiveFlagAction = createAction<{
    is2DFlagDeselected?: boolean
}>('resetActiveFlagAction')

export function* handleResetActiveFlag(action: ReturnType<typeof resetActiveFlagAction>) {
    const { is2DFlagDeselected } = action.payload || {}
    const isOpenFlagForm = yield select(selectIsFlagFormOpen)

    if (isOpenFlagForm && is2DFlagDeselected) {
        return
    }

    const paperManager = yield call(managers.get2DManager)

    if (!paperManager) return

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    const activeFlag: NormalizedFlag | null = yield select(selectMaterialActiveFlag)

    if (!activeFlag) return

    const items: paper.Item[] | null = yield call(
        workspaceTool.getItemsWithCriteria,
        'data',
        (data) => data.flag_id === activeFlag.id
    )

    if (items) {
        items.forEach((item) => {
            if (item && item.children && item.children.length > 0) {
                // Flag structure:
                // children[0] = Path object (the flag's background shape/border)
                // children[1] = PointText object (the text content inside the flag)
                const flagCompound = item.children[0]

                if (flagCompound) {
                    flagCompound.strokeWidth = FLAG_STROKE_WIDTH_DESELECTED
                }
            }
        })
    }

    yield put(resetActiveFlag())
    yield put(setDisableFlagTool(false))
}

export function* watchForResetActiveFlagAction() {
    yield takeEvery(resetActiveFlagAction.type, handleResetActiveFlag)
}
